import { supabase } from '../lib/supabase';

export interface SignUpOptions {
  full_name?: string;
  [key: string]: any;
}

export class AuthService {
  static async signIn(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;
    return data;
  }

  static async signUp(email: string, password: string, options?: SignUpOptions) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: options,
      },
    });

    if (error) throw error;
    return data;
  }

  static async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  }

  static async signInWithGoogle() {
    // Always use the production domain for OAuth redirects
    const redirectUrl = import.meta.env.VITE_APP_URL || 'https://tickethauk.type1bsolutions.today';
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${redirectUrl}/auth/callback`,
      },
    });

    if (error) throw error;
    return data;
  }

  static async signInWithGitHub() {
    // Always use the production domain for OAuth redirects
    const redirectUrl = import.meta.env.VITE_APP_URL || 'https://tickethauk.type1bsolutions.today';
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'github',
      options: {
        redirectTo: `${redirectUrl}/auth/callback`,
      },
    });

    if (error) throw error;
    return data;
  }

  static async signInWithApple() {
    // Always use the production domain for OAuth redirects
    const redirectUrl = import.meta.env.VITE_APP_URL || 'https://tickethauk.type1bsolutions.today';
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'apple',
      options: {
        redirectTo: `${redirectUrl}/auth/callback`,
      },
    });

    if (error) throw error;
    return data;
  }

  static async resetPassword(email: string) {
    // Always use the production domain for email redirects
    const redirectUrl = import.meta.env.VITE_APP_URL || 'https://tickethauk.type1bsolutions.today';
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${redirectUrl}/reset-password`,
    });

    if (error) throw error;
  }

  static async updatePassword(newPassword: string) {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) throw error;
  }

  static async getSession() {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return data.session;
  }

  static async getUser() {
    const { data, error } = await supabase.auth.getUser();
    if (error) throw error;
    return data.user;
  }

  static async getProfile(userId: string) {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (error) throw error;
    return data;
  }

  static async updateProfile(userId: string, updates: any) {
    const { data, error } = await supabase
      .from('profiles')
      .update(updates)
      .eq('id', userId)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  }
}